import { z } from 'zod';

const FULL_NAME_MAX_LENGTH = 255;

// Each word must contain at least one letter and may otherwise include
// hyphens, apostrophes, periods, and parentheses — covering real names like
// "Al-Mosly", "O'Brien", "Mohammed S." and annotated prefills like
// "(Partner)". Digits and other symbols are still rejected.
const NAME_PART = /^(?=.*\p{Letter})[\p{Letter}'.()-]+$/u;

export function isFullName(value: string): boolean {
  const parts = value.trim().split(/\s+/);
  if (parts.length < 2) return false;
  return parts.every((part) => part.length >= 2 && NAME_PART.test(part));
}

export const FullNameSchema = z
  .string()
  .max(FULL_NAME_MAX_LENGTH)
  .refine(isFullName, {
    message: 'auth:nameMustBeFullName',
  });
